import { Box } from "@mui/material";
import { DotLegalSelect, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { AutoRenewalDurationType, ContractModel } from "../Contract.types.ts";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { DotLegalSelectOption } from "../../../common/components/dotLegalMultiSelect/DotLegalMultiSelect.types.ts";
import { useAutoRenewalDurationFieldStyles } from "./AutoRenewalDurationField.styles.ts";

export interface AutoRenewalDurationFieldProps {
    /** Suppresses the field's help icon, for a view where the same field is shown twice. */
    hideToolTip?: boolean;
    autoRenewalDuration: number | undefined;
    autoRenewalDurationType: number | undefined;
    onChange: (changeFunc: (contract: ContractModel) => void) => Promise<void>;
    disabled: boolean;
    readOnly: boolean;
    noMargin?: boolean;
}

function AutoRenewalDurationField(props: AutoRenewalDurationFieldProps) {
    const { translateString } = useTranslation();
    const styles = useAutoRenewalDurationFieldStyles(props.autoRenewalDuration !== undefined || props.autoRenewalDurationType !== undefined);

    const durationTypeOptions: Array<DotLegalSelectOption> = [
        { id: AutoRenewalDurationType.Months.toString(), name: translateString("months") },
        { id: AutoRenewalDurationType.Years.toString(), name: translateString("years") },
    ];

    return (
        // The margins a lone field gives itself, so the row is spaced like the fields around it.
        <Box marginTop={props.noMargin ? 0 : 2} marginBottom={props.noMargin ? 0 : 1}>
            <Box sx={styles.combinedField}>
                <DotLegalTextField
                    onlyNumber={"integer"}
                    label={translateString("autoRenewalDuration")}
                    value={props.autoRenewalDuration?.toString() ?? null}
                    debounce={false}
                    noMargin
                    onChange={
                        props.readOnly
                            ? () => {}
                            : (value) => {
                                  props.onChange((c) => {
                                      c.autoRenewalDuration = value ? parseInt(value) : undefined;
                                  });
                              }
                    }
                    disabled={props.disabled}
                />
                <DotLegalSelect
                    selectedItem={props.autoRenewalDurationType?.toString() ?? null}
                    options={durationTypeOptions}
                    onChange={
                        props.readOnly
                            ? () => {}
                            : (value) => {
                                  props.onChange((c) => {
                                      c.autoRenewalDurationType = value ? parseInt(value) : undefined;
                                  });
                              }
                    }
                    label={""}
                    placeholder={translateString("durationType")}
                    noOptionsLabel={translateString("noOptions")}
                    noMargin
                    disabled={props.disabled}
                    toolTipText={props.hideToolTip ? undefined : translateString("autoRenewalPeriodToolTip")}
                />
            </Box>
        </Box>
    );
}

export default AutoRenewalDurationField;
